/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 *
 * This code and associated materials are protected by copyright laws and
 * international treaties. Unauthorized use, reproduction, distribution, or
 * modification of any content from Knowledge for Decisions (K4D) is strictly
 * prohibited. For inquiries regarding the use or licensing of K4D's
 * copyrighted materials, please contact us at contact@k4d.com.br. "Knowledge
 * for Decisions (K4D)" and the slogan "Using data to make precise decisions"
 * are registered trademarks of Knowledge for Decisions (K4D).
 */

import common from '../locales/pt-BR/common.json';
import location from '../locales/pt-BR/location.json';
import propertiesFeature from '../locales/pt-BR/features/properties.json';
import visits from '../locales/pt-BR/features/visits.json';
import members from '../locales/pt-BR/features/members.json';
import blog from '../locales/pt-BR/features/blog.json';
import popups from '../locales/pt-BR/features/popups.json';
import filters from '../locales/pt-BR/features/filters.json';
import pricing from '../locales/pt-BR/features/pricing.json';
import clients from '../locales/pt-BR/features/clients.json';
import cookieConsent from '../locales/pt-BR/features/cookie-consent.json';
import agencySettings from '../locales/pt-BR/features/agency-settings.json';
import agenda from '../locales/pt-BR/features/agenda.json';
import landing from '../locales/pt-BR/pages/landing.json';
import earlyAccess from '../locales/pt-BR/pages/early-access.json';
import notFound from '../locales/pt-BR/pages/not-found.json';
import error from '../locales/pt-BR/pages/error.json';
import agencies from '../locales/pt-BR/pages/agencies.json';
import propertiesPage from '../locales/pt-BR/pages/properties.json';
import manageAgencies from '../locales/pt-BR/pages/manage-agencies.json';
import manageProperties from '../locales/pt-BR/pages/manage-properties.json';
import registerAgency from '../locales/pt-BR/pages/register-agency.json';
import propertyPages from '../locales/pt-BR/pages/property-pages.json';
import layout from '../locales/pt-BR/pages/layout.json';
import policy from '../locales/pt-BR/pages/policy.json';
import onboarding from '../locales/pt-BR/pages/onboarding.json';
import welcome from '../locales/pt-BR/pages/welcome.json';
import userSettings from '../locales/pt-BR/pages/user-settings.json';
import publicProperty from '../locales/pt-BR/pages/public-property.json';
import dataRights from '../locales/pt-BR/pages/data-rights.json';
import visitsPage from '../locales/pt-BR/pages/visits.json';
import agencySiteConfig from '../locales/pt-BR/features/agency-site-config.json';
import deals from '../locales/pt-BR/features/deals.json';
import attendances from '../locales/pt-BR/features/attendances.json';
import leases from '../locales/pt-BR/features/leases.json';
import sales from '../locales/pt-BR/features/sales.json';
import vistories from '../locales/pt-BR/features/vistories.json';
import partnerships from '../locales/pt-BR/features/partnerships.json';
import launches from '../locales/pt-BR/features/launches.json';
import productTour from '../locales/pt-BR/features/product-tour.json';
import subscription from '../locales/pt-BR/features/subscription.json';
import spreadsheets from '../locales/pt-BR/features/spreadsheets.json';
import supportAccess from '../locales/pt-BR/features/support-access.json';
import assistant from '../locales/pt-BR/features/assistant.json';

/**
 * Brazilian Portuguese translation namespaces.
 */
export const ptBR = {
  common,
  location,
  'features/properties': propertiesFeature,
  '@features/properties': propertiesFeature,
  'features/visits': visits,
  'features/members': members,
  'features/blog': blog,
  'features/popups': popups,
  'features/filters': filters,
  'features/pricing': pricing,
  'features/clients': clients,
  '@features/clients': clients,
  'features/cookie-consent': cookieConsent,
  'features/agency-settings': agencySettings,
  'features/agenda': agenda,
  '@pages/landing': landing,
  '@pages/early-access': earlyAccess,
  '@pages/not-found': notFound,
  '@pages/error': error,
  '@pages/agencies': agencies,
  '@pages/properties': propertiesPage,
  '@pages/manage-agencies': manageAgencies,
  '@pages/manage-properties': manageProperties,
  '@pages/register-agency': registerAgency,
  '@pages/property-pages': propertyPages,
  '@pages/layout': layout,
  '@pages/policy': policy,
  '@pages/onboarding': onboarding,
  '@pages/welcome': welcome,
  '@pages/user-settings': userSettings,
  '@pages/public-property': publicProperty,
  '@pages/data-rights': dataRights,
  '@pages/visits': visitsPage,
  'features/agency-site-config': agencySiteConfig,
  'features/deals': deals,
  'features/attendances': attendances,
  'features/leases': leases,
  'features/sales': sales,
  'features/vistories': vistories,
  'features/partnerships': partnerships,
  'features/launches': launches,
  'features/product-tour': productTour,
  'features/subscription': subscription,
  'features/spreadsheets': spreadsheets,
  'features/support-access': supportAccess,
  'features/assistant': assistant,
};
